import { AppRoutes } from "../../../AppRoutes";
import { Pie } from "@ant-design/plots";
import React, { Component } from "react";

class AdnPie extends Component {
    shouldComponentUpdate(nextProps) {
        if (nextProps.offerTypesconfig.data !== this.props.offerTypesconfig.data) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        return (
            <Pie
                {...this.props.offerTypesconfig}
                onEvent={(...args) => {
                    if (args[1].type == "plot:click" && args[1].data != null) {
                        let offerTypeYear = args[1].data.data ? args[1].data.data.year : "";
                        let offerTypeMonth = args[1].data.data
                            ? args[1].data.data.month
                            : "";
                        let offerTypeId = args[1].data.data
                            ? args[1].data.data.offerTypeId
                            : "";

                        this.props.navigate(
                            AppRoutes.offerList.createPathWithSearch(
                                offerTypeId,
                                offerTypeMonth,
                                offerTypeYear
                            )
                        );
                    }
                }}
            />
        );
    }
}

export default AdnPie;
